import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Row, Col, Form, Button, Card, Spinner, Alert, Table } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import arrayAppend from 'helpers/array-append';
import MasterPage from 'components/MasterPage';
import FileUploadMultiple, { File } from 'components/FileUploadMultiple';
import BR from 'date-fns/locale/pt-BR';
import Currency, { currencyReverse, DollarCurrency, EuroCurrency } from 'helpers/Currency';
import { formatDate, parseDateBR } from 'helpers/date';
import { api } from 'services';
import { DashboardOutlined } from '@material-ui/icons';
import banks from 'helpers/banks_codes.json';
import { InfoRounded } from '@material-ui/icons';
import Input from 'helpers/Input';
import { useParams, useHistory } from 'react-router-dom'
import FormSelectActions from './FormSelectActions';
import Select from 'react-select';

registerLocale('BR', BR);

const InvoiceForm = (props) => {
  const [serviceProvider, setServiceProvider] = useState('');
  const [document, setDocument] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [value, setValue] = useState('');
  const [valueNonRefundable, setValueNonRefundable] = useState('');
  const [description, setDescription] = useState('');
  const [nature, setNature] = useState('Reembolsável');
  const [costCenter, setCostCenter] = useState('');
  const [project, setProject] = useState('');
  const [projectAction, setProjectAction] = useState('');
  const [files, setFiles] = useState([]);
  const [filesComments, setFilesComments] = useState([]);
  const [apportionment, setApportionment] = useState('');
  const [tasks, setTasks] = useState([]);
  const [tasksSelected, setTasksSelected] = useState([]);
  const [hasAmountTasks, setHasAmountTasks] = useState(false);
  const [amount_tasks, setAmountTasks] = useState('');
  const [taskItems, setTaskItems] = useState([]);
  const [hasContract, setHasContract] = useState(false);
  const [isLoad, setLoad] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [bankCode, setBankCode] = useState('');
  const [agency, setAgency] = useState('');
  const [account, setAccount] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [issuanceDate, setIssuanceDate] = useState('');
  const [isAdvance, setIsAdvance] = useState(false);
  const [expenseParent, setExpenseParent] = useState(null);
  const [listActions, setListActions] = useState([]);
  const [listActionsSelected, setListActionsSelected] = useState([]);
  const [loadActions, setLoadActions] = useState(false);
  const [alreadyPaid, setAlreadyPaid] = useState(false);

  const dueDateMin = new Date(new Date().setDate(new Date().getDate() + 7));

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  let query = useQuery();

  const { parent_id } = useParams();
  const history = useHistory();

  useEffect(() => {
    api
      .get('task-groups/list-for-action')
      .then(({ data }) => setTasks(data));

    if (parent_id) {
      setLoad(true)
      api
        .get('invoice',{ params: { parent_id: parent_id } })
        .then(({ data }) => {
          let lang = 'pt-br' 
          let code = 'BRL'

          if (data.currency == 2) {
            lang = 'en-US'
            code = 'USD'
          } else if (data.currency == 3) {
            lang = 'de-DE'
            code = 'EUR'
          }
          setServiceProvider(data.service_provider)
          setValue(data.value)
          setValueNonRefundable(data.non_refundable)
          setDocument(data.document)
          setIssuanceDate(data.issuance_date ? new Date(data.issuance_date) : "")
          setInvoiceNumber(data.invoice_number)
          setDueDate(data.due_date ? new Date(data.due_date) : "")
          setPaymentMethod(data.payment_method_id)
          setBankCode(data.bank_code)
          setAgency(data.agency)
          setAccount(data.account)
          setProject(data.project)
          setProjectAction(data.project_action)
          setDescription(data.description)
          setExpenseParent({ ...{ lang, code}, ...data })
        })
        .finally(() => setLoad(false));     
    }
  }, []);

  const currencyInput = (prop) => {
    if (prop.currency == 2) {
      return (
        <DollarCurrency 
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          required
        />
      )
    } else if (prop.currency == 3) {
      return (
        <EuroCurrency 
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          required
        />
      )
    }

    return (
      <Currency
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        required
      />
    )
  }

  useEffect(() => {
    let filter = {
      task_id:tasksSelected.map(a=>(a.value)).join(','),
      status_id:'9,21,13'
    };
    if(tasksSelected.length > 0){
      setLoadActions(true);
      api.get('actions',{params:filter}).then(({data})=>{
        setListActions(data.data)
        setLoadActions(false);
      });
    }
  },[tasksSelected]);

  const { t } = useTranslation();

  const handleSave = () => {
    const formData = new FormData();
    setLoad(true);

    let status_id = 6; //on_approval
    if (parent_id) {
        formData.append('parent_id', parent_id);
      
      //status_id = 8; //approved
    }

    formData.append('service_provider', serviceProvider);
    formData.append('invoice_number', invoiceNumber ? invoiceNumber : "");
    formData.append('due_date', dueDate ? formatDate(dueDate) : '');
    formData.append('value', currencyReverse(value));
    formData.append('non_refundable', currencyReverse(valueNonRefundable));
    formData.append('description', description);
    formData.append('nature', currencyReverse(value)>0?"Reembolsável":"Não Reembolsável");
    //formData.append('cost_center', costCenter);
    formData.append('project', project);
    formData.append('project_action', projectAction);
    //formData.append('vinculated_nf', 1);
    formData.append('has_contract', hasContract ? 1 : 0);
    formData.append('status_id', status_id);
    formData.append('issuance_date', issuanceDate ? formatDate(issuanceDate) : '');
    arrayAppend(formData, 'files', files);
    arrayAppend(formData, 'files_comments', filesComments);
    
    formData.append('document', document);

    formData.append('payment_method_id', paymentMethod);
    formData.append('billet_due_date', paymentMethod == 1 ? formatDate(dueDate): "");
    formData.append('bank_code', paymentMethod == 2 ? bankCode : "");
    formData.append('bank_name', paymentMethod == 2 ? banks.filter(item => item.value == bankCode)[0].label : "");
    formData.append('agency', paymentMethod == 2 ? agency : "");
    formData.append('account', paymentMethod == 2 ? account : "");
    
    if(apportionment === 'yes'){
      formData.append('apportionment', true);
      listActionsSelected.forEach((a,k)=>{
        formData.append(`action_list[${k}][value]`,a.value);
        formData.append(`action_list[${k}][action_id]`,a.id);
        formData.append(`action_list[${k}][value_cotacao]`,a.value_cotacao);
        formData.append(`action_list[${k}][currency]`,a.currency);
      })
    }

    formData.append('is_advance', isAdvance ? 1 : 0);
    formData.append('already_paid', alreadyPaid? 1 : 0);

    api
      .post('expense-descriptions', formData, {
        headers: {
          'X-Success-Message': 'Nota Fiscal cadastrado com sucesso',
          'X-Redirect': parent_id ? '/files/advance' : '/files',
          'X-Show-Alert': true
        }
      })
      .then(() => { })
      .finally(() => setLoad(false))
      .catch(() => setLoad(false));
  };

  // const handleChangeTask = (e) => {
  //   setTask(e.target.value);
  //   tasks.forEach((group) => {
  //     group.tasks.forEach((task) => {
  //       if (parseInt(e.target.value) === task.id) {
  //         setHasAmountTasks(task.has_quantity);
  //         setAmountTasks('');
  //         setTaskItems([]);
  //       }
  //     });
  //   });
  // };

  const bankAccountRender = () => ( // dados conta bancaria 
    <Row>
      <Col xs={12}>
        <Form.Group>
          <Form.Label>Banco</Form.Label>
          <Form.Control
            as="select"
            value={bankCode}
            onChange={(e)=> setBankCode(e.target.value)}
          >
            <option value="" selected>Selecione Um banco</option>
            {banks.map(bank => (
              <option value={bank.value}>{`${bank.value} - ${bank.label}`}</option>
            ))}
          </Form.Control>
        </Form.Group>
      </Col>
      <Col>
        <Form.Group>
          <Form.Label>Agência</Form.Label>
          <Form.Control
            value={agency}
            onChange={(e) => setAgency(e.target.value)}
            required={paymentMethod == 2}
          />
        </Form.Group>
      </Col>
      <Col>
        <Form.Group>
          <Form.Label>Conta</Form.Label>
          <Form.Control
            value={account}
            onChange={(e) => setAccount(e.target.value)}
            required={paymentMethod == 2}
          />
        </Form.Group>
      </Col>        
      <Col>
        <Form.Group>
          <Form.Label>CNPJ</Form.Label>
          <Form.Control
            value={document}
            required={paymentMethod == 2}
            disabled
          />
        </Form.Group>
      </Col>
    </Row>
  )

  const billetRender = () => ( // dados boleto
    <Row>
      <Col xs={6}>
        <Form.Group>
          <Form.Label>Data de Vencimento</Form.Label>
          <Form.Control 
            value={dueDate ? parseDateBR(formatDate(dueDate)) : ""}
            disabled
          />
          {/* <DatePicker          
            className="form-control"
            dateFormat="dd/MM/yyyy"
            locale="pt_BR"
            selected={billetDueDate}
            onChange={(date) => setBilletDueDate(date)}
            minDate={new Date(new Date().setDate(new Date().getDate() + 10))}
          /> */}
        </Form.Group>
      </Col>
    </Row>
  )

  return (
    <>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">{t('title:add invoice')}</h4>
          </Col>
        </Row>
        {parent_id ? (
          <Row>
            <Col md="12">
              <h4 className="title-dashboard mt-2">Dados do adiantamento</h4>
            </Col>
            <Col md="12">
              <Table bordered striped>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Razão Social</th>
                    <th>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {expenseParent ? (
                    <tr>
                      <td>{expenseParent.id}</td>
                      <td>{expenseParent.service_provider}</td>
                      <td>{new Intl.NumberFormat(expenseParent.lang, { style: 'currency', currency: expenseParent.code }).format(expenseParent.value)}</td>
                    </tr>
                  ) : isLoad ? (
                    <tr>
                      <td colSpan="3" className="text-center">
                        <Spinner animation="border" variant="dark" />
                      </td>
                    </tr>
                  ) : ""}                  
                </tbody>
              </Table>
              <hr/>
            </Col>
          </Row>
        ) : ''}
        <Row className="mb-2">
          <Col>
            <Form.Group>
              <Form.Label>Pagamento efetuado ?</Form.Label>
              <Form.Control
                as="select"
                value={alreadyPaid ? 1 : 0}
                onChange={(e) => setAlreadyPaid(e.target.value == 1 ? true : false)}
                required
              >
                <option value={0}>{t('label:no')}</option>
                <option value={1}>{t('label:yes')}</option>
              </Form.Control>
            </Form.Group>
          </Col>
          {!parent_id ? (
            <Col>
              <Form.Group>
                <Form.Label>{t('label:apportionment invoice')}</Form.Label>
                <Form.Control
                  as="select"
                  value={apportionment}
                  onChange={(e) => setApportionment(e.target.value)}
                  required
                >
                  <option value="">{t('label:select')}</option>
                  <option value={'yes'}>{t('label:yes')}</option>
                  <option value={'no'}>{t('label:no')}</option>
                </Form.Control>
              </Form.Group>
            </Col>
          ) : ''}
          
          <Col>
            <Form.Group>
              <Form.Label>{t('label:service provider')}</Form.Label>
              <Form.Control
                value={serviceProvider}
                onChange={(e) => setServiceProvider(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>{t('label:registered number')}</Form.Label>
              <Input.CNPJ
                value={document}
                onChange={(e) => setDocument(e.target.value)}
                required
              />
              {/* <Form.Control
                value={document}
                onChange={(e) => setDocument(e.target.value)}
                required
              /> */}
            </Form.Group>
          </Col>
          {!parent_id ? (
            <Col>
              <Form.Group>
                <Form.Label>Adiantamento ?</Form.Label>
                <Form.Check
                  disabled={alreadyPaid}
                  onChange={(e) => setIsAdvance(e.target.checked)}
                  type="checkbox" 
                  label="Sim"
                />
              </Form.Group>
            </Col>
          ): ''}          
        </Row>
        <Row>
          <Col>
            <Form.Group>
              <Form.Label>{t('label:invoice number')}</Form.Label>
              <Form.Control
                value={invoiceNumber}
                onChange={(e) => setInvoiceNumber(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>{t('label:expiry')}</Form.Label>
              <DatePicker
                className="form-control"
                dateFormat="dd/MM/yyyy"
                locale="pt_BR"
                selected={dueDate}
                onChange={(date) => setDueDate(date)}
                minDate={paymentMethod == 1 ? dueDateMin : ""}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>{t('label:issuance_date')}</Form.Label>
              <DatePicker
                className="form-control"
                dateFormat="dd/MM/yyyy"
                locale="pt_BR"
                selected={issuanceDate}
                onChange={(date) => {setIssuanceDate(date);}}
                // minDate={paymentMethod == 1 ? dueDateMin : ""}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        {!alreadyPaid ? (<>
          <Row className="mt-2 mb-1">
            <Col><h5>Pagamento</h5></Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Form.Group>
                <Form.Label>Forma de Pagamento</Form.Label>
                <Form.Control
                  as="select"
                  value={paymentMethod}
                  onChange={(e) => {
                    setPaymentMethod(e.target.value);
                    if (e.target.value == 1 && dueDate != "") {
                      if (dueDateMin > dueDate) {
                        setDueDate("");
                        setShowAlert(true);
                      }                     
                    }
                  }}
                >
                  <option value="" selected disabled>Selecione uma forma de Pagamento</option>
                  <option value={1}>Boleto</option>
                  <option value={2}>Transferência Bancária</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col>
              {paymentMethod == 1 
                ? billetRender() 
                : paymentMethod == 2 
                  ? bankAccountRender()
                  : null 
              }
            </Col>
          </Row>
        </>): null }
          <Row>
            <Col>
              {apportionment === 'yes' ? (<>
                <Form.Group>
                  <Form.Label>{t('label:activity')}</Form.Label>
                  {/* <Form.Control
                    as="select"
                    value={task}
                    onChange={handleChangeTask}
                    required={apportionment === 'yes' ? true : false}
                  >
                    <option disabled value="">
                      {t('label:select')}
                    </option>
                    {tasks.map((group, k) => (
                      <optgroup key={k} label={t(`task:${group.name}`)}>
                        {group.tasks.map((task, k2) => (
                          <option key={k2} value={task.id}>
                            {t(`task:${task.name}`)}
                          </option>
                        ))}
                      </optgroup>
                    ))}
                  </Form.Control> */}
                  <Select
                    closeMenuOnSelect={false}
                    isMulti
                    value={tasksSelected}
                    options={
                      [...tasks.map(group=>({
                          label:group.name,
                          options: [
                            ...group.tasks.map(task => ({
                              value:task.id,
                              label:task.name
                            }))
                          ]
                      }))]
                    }
                    onChange={(selected) => setTasksSelected(selected?selected:[])}
                  />
                </Form.Group>
                {tasksSelected.length>0?(
                  <Form.Group>
                    <Form.Label>{t('label:actions')}</Form.Label>
                    <FormSelectActions list={listActions} onChange={(v)=>{
                      setListActionsSelected(v.map(a=>({
                        id:a.id,
                        value:a.value_d,
                        value_cotacao:a.currency_d=="1"?a.med_cotacao:1,
                        currency:a.currency_d
                      })));
                    }}
                    load={loadActions}
                    value_nf={value}/>
                  </Form.Group>
                ):''}
              </>) : (
                  ''
                )}
            </Col>
          </Row>
        {!alreadyPaid ? (<>
          <Row className="mt-2 mb-1">
            <Col>
              <h5>{t('title:project info')}</h5>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:project')}</Form.Label>
                <Form.Control
                  value={project}
                  onChange={(e) => setProject(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:project action')}</Form.Label>
                <Form.Control
                  value={projectAction}
                  onChange={(e) => setProjectAction(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
        </>) : (<></>)}
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:value')} - Reembolsável</Form.Label>                   
                {expenseParent ? 
                  currencyInput(expenseParent) : 
                (
                  <Currency
                    value={value}
                    onChange={(e) => {
                      setValue(e.target.value);
                    }}
                    required
                  />
                )}
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:value')} - Não Reembolsável</Form.Label>                  
                {expenseParent ? 
                  currencyInput(expenseParent) : 
                (
                  <Currency
                    value={valueNonRefundable}
                    onChange={(e) => {
                      setValueNonRefundable(e.target.value);
                    }}
                    required
                  />
                )}
              </Form.Group>
            </Col>
            {paymentMethod == 1 && showAlert ? (
              <>
                <Col xs={12}>
                  <Alert variant="danger" onClose={() => setShowAlert(false)} dismissible>
                    <InfoRounded />{' '} 
                    A data de vencimento para BOLETO deve ser de no mínimo 10 dias. Por favor altere a data de vencimento.
                  </Alert>
                </Col>
              </>
            ) : null}
          </Row>
        {!alreadyPaid ? (<>
          <Row>
            <Col>
              <Form.Group>
                <Form.Check
                  id="test"
                  type="checkbox"
                  label={t('phrase:contract')}
                  checked={hasContract}
                  onChange={(e) => setHasContract(e.target.checked)}
                />
              </Form.Group>
            </Col>
          </Row>
        </>) : null}
        
        <Row>
          <Col>
            <Form.Group>
              <Form.Label>{t('label:brief description')}</Form.Label>
              <Form.Control
                as="textarea"
                rows="4"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        {!isAdvance ? (<>
          <Row>
            <Col>
              <FileUploadMultiple
                files={files}
                setFiles={(files) => setFiles(files)}
                filesComments={filesComments}
                setFilesComments={(filesComments) =>
                  setFilesComments(filesComments)
                }
                existingFiles={[]}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              {description.files &&
                description.files.map((file, k) => (
                  <File
                    key={k}
                    extension={file.extension}
                    comment={file.comment}
                    uri={file.uri}
                  />
                ))}
            </Col>
          </Row>
        </>) : null }
        {isLoad ? (
          <Row className="col">
            <Spinner animation="border" style={{ color: '#e05c17' }} />
            <h6 className="m-2">Salvando...</h6>
          </Row>
        ) : (
            <Row>
              <Col>
                <Button size="sm" onClick={() => handleSave()}>
                  {t('label:save')}
                </Button>
              </Col>
            </Row>
          )}
      </Card.Body>
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

const connectRedux = connect(mapStateToProps, mapDispatchToProps)(InvoiceForm);

export default MasterPage(connectRedux);

